import { app } from '../../../../app';

class PasswordAuthenticationPoliciesService{

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getPasswordPolicyList(companyId){
        return this.$http
            .get(`app/rest/companies/${companyId}/passwordpolicies`)
            .then(response => response.data);
            //Returns: list of PasswordPolicyDTO
    }

    createNewPasswordPolicy(companyId){
        return this.$http
            .post(`app/rest/companies/${companyId}/passwordpolicies`)
            .then(response => response.data);
            //Returns: CompanyPasswordPolicy
    }

    getPasswordPolicyDetails(companyId,policyId){
        return this.$http
            .get(`app/rest/companies/${companyId}/passwordpolicies/${policyId}`)
            .then(response => response.data);
            //Returns: CompanyPasswordPolicy
    }

    editPasswordPolicyDetails(companyId,policyId,policy){
        return this.$http
            .put(`app/rest/companies/${companyId}/passwordpolicies/${policyId}`,policy)
            .then(response => response.data);
            //Request body: CompanyPasswordPolicy
    }

    deletePasswordPolicy(companyId,policyId){
        return this.$http
            .delete(`app/rest/companies/${companyId}/passwordpolicies/${policyId}`)
            .then(response => response.data);
    }

    applyPasswordPolicyToApplication(companyId,policyId,applicationId){
        return this.$http
            .post(`app/rest/companies/${companyId}/passwordpolicies/${policyId}?action=applytoapp&appid=${applicationId}`)
            .then(response => response.data);
    }

    removePasswordPolicyFromApplication(companyId,policyId,applicationId){
        return this.$http
            .post(`app/rest/companies/${companyId}/passwordpolicies/${policyId}?action=removefromapp&appid=${applicationId}`)
            .then(response => response.data);
    }

    resetPasswordPolicy(companyId,policyId){
        return this.$http
            .put(`app/rest/companies/${companyId}/passwordpolicies/${policyId}?action=reset`)
            .then(response => response.data);
    }

}

app.service('PasswordAuthenticationPoliciesService', PasswordAuthenticationPoliciesService);


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/password-authentication-policy.service.js